var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsvUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.835 10.4984C12.835 9.20971 13.8796 8.16504 15.1683 8.16504H39.8685C40.4873 8.16504 41.0808 8.41087 41.5184 8.84846L49.4849 16.815C49.9225 17.2525 50.1683 17.846 50.1683 18.4649V57.165C50.1683 58.4537 49.1236 59.4984 47.835 59.4984H15.1683C13.8796 59.4984 12.835 58.4537 12.835 57.165V10.4984Z",
    fill: "#F0F0F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.835,
    y: 32.665,
    width: 9.33333,
    height: 3.5,
    rx: 1.16667,
    fill: "#C3C5D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.835,
    y: 24.498,
    width: 9.33333,
    height: 3.5,
    rx: 1.16667,
    fill: "#C3C5D5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.835,
    y: 40.832,
    width: 9.33333,
    height: 3.5,
    rx: 1.16667,
    fill: "#C3C5D5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.835,
    y: 48.998,
    width: 9.33333,
    height: 3.5,
    rx: 1.16667,
    fill: "#C3C5D5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.835,
    y: 32.665,
    width: 9.33333,
    height: 3.5,
    rx: 1.16667,
    fill: "#C3C5D5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33.835,
    y: 24.498,
    width: 9.33333,
    height: 3.5,
    rx: 1.16667,
    fill: "#C3C5D5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33.835,
    y: 40.832,
    width: 9.33333,
    height: 3.5,
    rx: 1.16667,
    fill: "#C3C5D5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33.835,
    y: 48.998,
    width: 9.33333,
    height: 3.5,
    rx: 1.16667,
    fill: "#C3C5D5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.8353,
    cy: 52.4979,
    r: 9.33333,
    fill: "#9799B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8353 48.9976V55.9976M47.8353 48.9976L50.1687 51.3309M47.8353 48.9976L45.502 51.3309",
    stroke: "#F0F0F4",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvUpload);
export default __webpack_public_path__ + "static/media/csvUpload.b8853b77997e301df964275f3c390884.svg";
export { ForwardRef as ReactComponent };